import tns from '@/lib/tiny-slider/tiny-slider.js';

document.addEventListener(
    "DOMContentLoaded", () => {
        var tcCarousel = tns({
            container: '.control-gallery .gallery-items',
            items: 1,
            slideBy: 1,
            autoplay: true,
            autoplayButtonOutput: false,
            controls: false,
            nav: false,
            speed: 800,
            responsive: {
                700: {
                    items: 2
                },
                1000: {
                    items: 3
                },
                1200: {
                    disable: true
                }
            }
        });
    }

);
